/**
 * @generated SignedSource<<d61d42eb7e08165b7fbeb18350da9a21>>
 * @relayHash 18d1c881067705e26191e9a11c0b64cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 277e45666d1be9be7333e0343963a555c5a4aff114faa3e93a9a2d3b0cdf9bc4

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateCoverPictureMutationBlogUpdateMutation$variables = {
  blogPostId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateCoverPictureMutationBlogUpdateMutation$data = {
  readonly confluence: {
    readonly updateValueBlogPostProperty: {
      readonly blogPostProperty: {
        readonly key: string;
        readonly value: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateCoverPictureMutationBlogUpdateMutation = {
  response: useUpdateCoverPictureMutationBlogUpdateMutation$data;
  variables: useUpdateCoverPictureMutationBlogUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogPostId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "blogPostId",
                "variableName": "blogPostId"
              },
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "propertyValue"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
        "kind": "LinkedField",
        "name": "updateValueBlogPostProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "ConfluenceBlogPostProperty",
            "kind": "LinkedField",
            "name": "blogPostProperty",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateCoverPictureMutationBlogUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateCoverPictureMutationBlogUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "18d1c881067705e26191e9a11c0b64cc",
    "id": "277e45666d1be9be7333e0343963a555c5a4aff114faa3e93a9a2d3b0cdf9bc4",
    "metadata": {},
    "name": "useUpdateCoverPictureMutationBlogUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateCoverPictureMutationBlogUpdateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{updateValueBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{key,value}}}}"
  }
};
})();

(node as any).hash = "8fd6bd1097a1eb060f954895a9a2730e";

export default node;
